/**
 * Vendors (Nuitee/Cupid) return a stock grey "NO IMAGE" graphic as a normal photo URL when a room or hotel has no photo.
 * It looks like a real photo to our code, so the empty-photos fallback (DEFAULT_HOTEL_IMAGE) never kicks in.
 * Drop these so the empty path shows our own placeholder.
 */
const VENDOR_PLACEHOLDER_FILENAME_PATTERN = /(?:^|\/)(?:room|hotel)-placeholder\.(?:jpe?g|png|webp)(?:[?#].*)?$/i;

export const isVendorPlaceholderPhotoUrl = (url: string | null | undefined): boolean => Boolean(url) && VENDOR_PLACEHOLDER_FILENAME_PATTERN.test(url as string);

export const withoutVendorPlaceholderPhotos = <T extends { url: string }>(photos: ReadonlyArray<T>): T[] => photos.filter(photo => !isVendorPlaceholderPhotoUrl(photo.url));
